import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import validatePassword from '../../utils/validatePassword';
import styles from './styles/password-change.module.css';

import InputField from './InputField';
import Button from '../common-women/Button';

export default function PasswordChange({ response, error, loading, handleModify, handleInitialize }) {
    const navigate = useNavigate();

    const initialForm = {
        userId: '',
        password: '',
        newPassword: '',
        confirmPassword: '',
        userIdError: false,
        passwordError: false,
        newPasswordError: false,
        confirmPasswordError: false,
        passwordMessage: '',
        newPasswordMessage: '',
        confirmPasswordMessage: ''
    };

    const [passwordForm, setPasswordForm] = useState(initialForm);

    const changeInput = (e) => {
        const { name, value } = e.target;

        if (name === 'newPassword') {
            const validation = validatePassword(value);

            setPasswordForm({
                ...passwordForm,
                [name]: value,
                newPasswordError: !validation.isValid,
                confirmPasswordError: (passwordForm.confirmPassword !== '') && (passwordForm.confirmPassword !== value),
                newPasswordMessage: !validation.isValid &&  `4~20자, 한글 및 공백 불가, 사용 불가 특수문자: \\ / ' " < > | $\``,
                confirmPasswordMessage: (passwordForm.confirmPassword !== '') && (passwordForm.confirmPassword !== value) && '새 비밀번호와 같지 않습니다.'
            });
        } else if (name === 'confirmPassword') {
            setPasswordForm({
                ...passwordForm,
                [name]: value,
                confirmPasswordError: value !== passwordForm.newPassword,
                confirmPasswordMessage: (value !== passwordForm.newPassword) && '새 비밀번호와 같지 않습니다.'
            });
        } else {
            setPasswordForm({
                ...passwordForm,
                [name]: value
            });
        }
    };

    const getActive = () => {
        return (
            passwordForm.userId !== '' && 
            passwordForm.password !== '' && 
            passwordForm.newPassword !== '' && 
            passwordForm.confirmPassword !== '' && 
            !passwordForm.newPasswordError && 
            !passwordForm.confirmPasswordError
        );
    };

    const getBtnStyle = () => {
        const isActive = getActive();
        return {
            backgroundColor: isActive ? '#825DFC' : '#A9A9AE',
            disabled: isActive ? '' : 'disabled'
        };
    };

    useEffect(() => {
        if (!loading && response) {
            setPasswordForm(initialForm);
            handleInitialize();
            navigate('/auth/login');
        }

        if (!loading && error && error.code === 401) {
            setPasswordForm({
                ...passwordForm,
                userIdError: true,
                passwordError: true,
                passwordMessage: '아이디 또는 비밀번호를 잘못 입력했습니다. 다시 시도해주세요.'
            })
        }

        if (!loading && error && error.code === 500) {
            setPasswordForm({
                ...passwordForm,
                confirmPasswordMessage: '비밀번호 변경 중 오류가 발생했습니다. 문제가 지속되면 관리자에게 문의해주세요.'
            })
        }
    }, [response, error, loading]);

    return (
        <div className={styles.wrapper}>
            <p className={styles.title}>비밀번호 변경</p>
            <div className={styles.boxInput}>
                <InputField
                    type='userId'
                    text='아이디'
                    placeholder='아이디를 입력해주세요'
                    name='userId'
                    value={passwordForm.userId}
                    error={passwordForm.userIdError}
                    handleChange={changeInput}
                />
                <InputField
                    type='password'
                    text='비밀번호'
                    placeholder='비밀번호를 입력해주세요'
                    name='password'
                    value={passwordForm.password}
                    error={passwordForm.passwordError}
                    message={passwordForm.passwordMessage}
                    handleChange={changeInput}
                />
            </div>
            <div className={styles.boxInput}>
                <InputField
                    type='password'
                    text='새 비밀번호'
                    placeholder='새 비밀번호를 입력해주세요'
                    name='newPassword'
                    value={passwordForm.newPassword}
                    error={passwordForm.newPasswordError}
                    message={passwordForm.newPasswordMessage}
                    handleChange={changeInput}
                />
                <InputField
                    type='password'
                    text='새 비밀번호 확인'
                    placeholder='새 비밀번호를 입력해주세요'
                    name='confirmPassword'
                    value={passwordForm.confirmPassword}
                    error={passwordForm.confirmPasswordError}
                    message={passwordForm.confirmPasswordMessage}
                    handleChange={changeInput}
                />
            </div>
            <Button
                text='변경하기'
                width='100%'
                height='52px'
                padding='14px 184px'
                borderRadius='5px'
                fontSize='20px'
                fontWeight='700'
                textColor='#FFF'
                onClick={getActive() ? () => handleModify(passwordForm) : null}
                {...getBtnStyle()}
            />
        </div>
    );
}
